import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import ReactGA from 'react-ga';
ReactGA.initialize('UA-180101768-1'); // add your tracking id here.
ReactGA.pageview(window.location.pathname + window.location.search);

ReactDOM.render(
  <React.StrictMode>
    <App />
    {/* <a
      href={`https://api.whatsapp.com/send?phone=&text=${encodeURI(
        "Hi, I have some questions about your platform"
      )}`}
      style={{
        position: "fixed",
        width: "50px",
        height: "50px",
        bottom: "20px",
        right: "20px",
        color: "#FFF",
        backgroundColor: "#25d366",
        borderRadius: "50px",
        textAlign: "center",
        fontSize: "30px",
        boxShadow: "2px 2px 6px #333",
        zIndex: 100,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textDecoration: "none",
      }}
      target="_blank"
      rel="noopener noreferrer"
    >
      <i className="fa fa-whatsapp" aria-hidden="true"></i>
    </a> */}
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
